export default __webpack_public_path__ + "static/media/happy-indian-couple-spending-time-together.d082d61f.png";